import React from "react";
import Icofont from "react-icofont";
import { Link } from "react-router-dom";
import "./footer.styles.css";
// import facebook from "../../assets/images/facebook.svg";
// import google from "../../assets/images/google-plus.svg";
// import twitter from "../../assets/images/twitter.svg";
// import IconComponent from "../iconcomponent/iconcomponent.component.jsx";

const Footer = () => {
  return (
    <React.Fragment>
      <footer id="footer">
        <div className="container">
          <div className="copyright">
            &copy; Copyright{" "}
            <strong>
              <span>NBRRI {new Date().getFullYear()}</span>
            </strong>
            . All Rights Reserved
          </div>
          <div className="credits">
            <a className="social-icons" href="">
              <Icofont icon="icofont-twitter social-icons" />
            </a>
            <a className="social-icons" href="">
              <Icofont icon="icofont-facebook social-icons" />
            </a>
            <a className="social-icons" href="">
              <Icofont icon="icofont-linkedin social-icons" />
            </a>
          </div>
        </div>
      </footer>
    </React.Fragment>
  );
};

export default Footer;
